// modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { find } from 'ramda';

// aliased
import DocumentTitle from 'components/DocumentTitle';
import ProjectDetails from 'components/ProjectDetails';
import projects from 'data/projects';
import companies from 'data/companies';

// local
import ProjectList from 'components/ProjectList';
import styles from './PortfolioView.pcss';

const projectBySlug = (projectSlug) => find(({ slug }) => (slug === projectSlug), projects);

export default class PortfolioView extends PureComponent {
  
  static propTypes = {
    history: PropTypes.shape({
      // push: PropTypes.func.isRequired,
      goBack: PropTypes.func.isRequired,
    }).isRequired,
    match: PropTypes.shape({
      url: PropTypes.string,
    }).isRequired,
  }
  static defaultProps = {}
  
  renderProjectList = () => (
    <ProjectList
      companies={ companies }
      projects={ projects }
      className={ styles.projectList } />
  )
  
  renderProjectDetails = ({ match: { params: { projectSlug } } }) => {
    const project = projectBySlug(projectSlug);
    // invalid project slug
    if (!project) return (<Redirect to={ this.props.match.url } />);
    const company = companies.find(({ slug }) => slug === project.company);
    return (
      <ProjectDetails
        className={ styles.projectDetails }
        company={ company }
        project={ project } />
    );
  }
  
  render() {
    return (
      <div className={ styles.portfolioView }>
        <DocumentTitle title={ 'Colby Dauphinais - Portfolio' } />
        <Route
          exact={ true }
          path={ this.props.match.url }
          render={ this.renderProjectList } />
        <Route
          exact={ true }
          path={ `${ this.props.match.url  }/:projectSlug` }
          render={ this.renderProjectDetails } />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/PortfolioView/index.jsx